import styled from "@emotion/styled";

export const TableWrapper = styled.div`
  margin: 0 -24px 32px;
`;
